import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { TipoPortariaEnum } from '../shared/enum/tipo-portaria.enum';
import { Portaria } from '../shared/model';
import { GrupoPortariaVO } from '../shared/model/grupo-portaria-vo.model';

@Injectable({
  providedIn: 'root'
})
export class PortariaService {

  constructor(private readonly http: McticHttpClient) {
  }

  obterPortariasTrocaPpbPdi(): Observable<Portaria[]> {
    return this.obterPortarias([TipoPortariaEnum.PortariaTrocaPpbPdi]);
  }

  obterPortariasPpb(): Observable<Portaria[]> {
    return this.obterPortariasHabilitacao([TipoPortariaEnum.PortariaPontuacao]);
  }

  obterPortariasPpbMetasEtapas(): Observable<Portaria[]> {
    return this.obterPortariasHabilitacao([TipoPortariaEnum.PortariaPontuacao, TipoPortariaEnum.PortariaEtapas]);
  }

  private obterPortarias(tipoPortaria: TipoPortariaEnum[]): Observable<Portaria[]> {
    return this.http.get(`/sepin-backend/rest/tipos-portarias/${tipoPortaria}/portarias`);
  }

  private obterPortariasHabilitacao(tipoPortaria: TipoPortariaEnum[]): Observable<Portaria[]> {
    return this.http.get(`/sepin-backend/rest/tipos-portarias/${tipoPortaria}/portarias-habilitacao`);
  }

  obterGrupoPortaria(idPortaria: number): Observable<GrupoPortariaVO[]> {
    return this.http.get(`/sepin-backend/rest/tipos-portarias/${idPortaria}/grupo-portarias`);
  }

}
